
import UserInfoBox from '@/components/UserInfoBox'
import { mapGetters } from 'vuex'
import { debounce } from '@/utils'
import goodsItem from '@/components/Bargain/buyer/item'
import { addQueryParams } from '@/utils'
import pzBadge from '@/components/pzBadge'
import GoodsListPage from '@/components/GoodsListPage'
import BargainSuccessTips from '@/components/Bargain/success-tips/index.vue'
export default {
	components: {
		pzBadge,
		goodsItem,
		GoodsListPage,
		UserInfoBox,
		BargainSuccessTips
	},
	watch: {
		$route: {
			handler(route) {
				this.navIndex = route.query?.status || null
				if (this.navIndex === 'SUCCESS') {
					// 等待设置小红点
					setTimeout(() => {
						const list = this.sellNavList.find(item => item.value === 'SUCCESS')
						const childrenDefaultVal = list?.children[0].value
						this.childrenIndex = this.navIndex === 'SUCCESS' ? childrenDefaultVal : null
						this.tabsNavChildren = list?.children || []
					}, 750)
				}
			},
			immediate: true
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			centerMenu: 'menu/centerMenu',
			userAccount: 'user/userAccount',
			/**
			 * 公共剩余砍价次数
			 */
			bargainCountConfig: 'bargain/bargainCountConfig',
			severTime: 'severTime'
		})
	},
	data() {
		return {
            query: null,
			/**
			 * 砍价设置
			 * @status 砍价是否可取消
			 * @dialog 是否显示设置弹窗
			 */
			setting: {
				status: false,
				dialog: false
			},
			/**
			 * tab选中的子级列表
			 */
			tabsNavChildren: [],
			navIndex: null,
			childrenIndex: null,
			sellNavList: [
				{ name: '全部', value: null },
				{
					name: '砍价中',
					value: 'IN_PROGRESS'
				},
				{
					name: '砍价成功',
					value: 'SUCCESS',
					children: [
						{ name: '待支付', value: 'NOT_PAID' },
						{ name: '已支付', value: 'PAID' },
						{ name: '已取消', value: 'CANCELLED' }
					]
				},
				{ name: '砍价失败/取消', value: 'FAILED' }
			],
			/**
			 * 列表相关
			 */
			lists: [],
			loading: false,
			pageInfo: {
				page: 1,
				pageSize: 5,
				total: 0
			}
		}
	},
  methods: {
    showAlert() {
      this.$confirm('新版砍价已迁移至消息中心，请前往查看', '温馨提示', {
        confirmButtonText: '去看看',
        cancelButtonText: '我知道了',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
			})
				.then(() => {
					this.$trackEvent({ eventType: 'click', trackParams: { eventName: '点击菜单栏-消息tab', userId: this.userinfo?.id }})
          this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 1)
          this.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', true)
				})
    },
        // 搜索
        onSearchOrder(){
            this.getBargainMeList()
        },
		/**
		 * 设置小红点
		 */
		async setMenuDot(menu) {
			const par = {
				action: {
					buyer: true
				}
			}
			const res = await this.$api.getBargainDot(par)

			const { bargainFailedDotNum, bargainInProgressDotNum, bargainPayCancel, bargainPayedDotNum, bargainPayingDotNum, bargainSuccessDotNum } = res.data
			const subMenuDotTotal = {
				FAILED: bargainFailedDotNum, // 砍价失败
				IN_PROGRESS: bargainInProgressDotNum, // 砍价中
				SUCCESS: bargainSuccessDotNum, // 砍价成功
				NOT_PAID: bargainPayingDotNum, // 待支付
				PAID: bargainPayedDotNum, // 已支付
				CANCELLED: bargainPayCancel // 已取消
			}

			function tree(data) {
				return data.map(item => {
					const updatedItem = { ...item }
					updatedItem.dot = subMenuDotTotal[updatedItem.value] || 0
					if (updatedItem.children) {
						updatedItem.children = tree(updatedItem.children) // 更新子节点
					}
					return updatedItem
				})
			}
			this.sellNavList = tree(menu)
		},
		/**
		 * 清除小红点
		 */
		async onClearBargainDot(isChildren = false) {
			if (!this.navIndex) return
			const par = {
				action: {
					buyer: true,
					scene: isChildren ? this.childrenIndex : this.navIndex
				}
			}
			const res = await this.$api.clearBargainDot(par)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			this.setTab()
			// 设置左侧菜单小红点数量
			this.$store.dispatch('user/UserCenterStatistics')
			this.$store.dispatch('menu/onSetCenterDotMenu', {
				menu: this.centerMenu,
				userAccount: this.userAccount
			})
		},
		setTab() {
			const tab = [...this.sellNavList]
			this.setMenuDot(tab)
		},
		/**
		 * 点击砍价设置
		 */
		onBargainSetting() {
			this.setting = {
				status: !!this.userinfo.bargainSuccessCancelOther,
				dialog: true
			}
		},
		/**
		 * 砍价设置确定
		 */
		onUpdateSetting: debounce(async function () {
			try {
				const res = await this.$api.bargainUpdate({
					action: {
						status: Boolean(this.setting.status)
					}
				})
				if (res.success) {
					const userinfo = await this.$store.dispatch('user/UserGetInfo')
					if (userinfo.success) {
						this.$message.success('修改成功')
						this.setting.dialog = false
					}
				}
			} catch (error) {}
		}),
		/**
		 * 切换item
		 * @param item
		 */
		async onActiveSellNav(item) {
			console.log('🚀 ~ onActiveSellNav ~ item:', item)
			if (this.navIndex === item.value) return
			this.navIndex = item.value
			// 选择砍价成功默认选中第一个子级
			const childrenDefaultVal = this.sellNavList.find(item => item.value === 'SUCCESS')?.children[0].value
			this.childrenIndex = this.navIndex === 'SUCCESS' ? childrenDefaultVal : null
			this.tabsNavChildren = item?.children || []
			this.pageInfo.page = 1
			this.pageInfo.total = 0
			// 只修改路由参数
			addQueryParams({ ...this.$route.query, status: item.value || '' })
			// 砍价中不消除小红点
			if (this.navIndex !== 'IN_PROGRESS') {
				if (this.navIndex === 'SUCCESS') {
					this.setTab()
					// 设置左侧菜单小红点数量
					this.$store.dispatch('user/UserCenterStatistics')
					this.$store.dispatch('menu/onSetCenterDotMenu', {
						menu: this.centerMenu,
						userAccount: this.userAccount
					})
				} else {
					this.onClearBargainDot()
				}
			}
			this.getBargainMeList()
		},
		/**
		 * 子级切换item
		 */
		onActiveSellNavChildren(vo) {
			if (this.childrenIndex === vo.value) return
			this.childrenIndex = vo.value
			this.pageInfo.page = 1
			if (vo.value !== 'NOT_PAID') {
				this.onClearBargainDot(true)
			}
			this.getBargainMeList()
		},
		/**
		 * 获取买家砍价列表
		 */
		async getBargainMeList() {
			try {
				this.loading = true
				let p = {
					action: {
						status: this.navIndex,
                        goodsNo: this.query,
						bargainOrderPayStatus: this.childrenIndex,

					},
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize
				}
				const res = await this.$api.bargainMeListv3(p)
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				data?.records.forEach(item => {
					item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
				})
				this.lists = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			} catch (err) {
				this.loading = false
			}
		},
		/**
		 * 分页相关
		 */
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getBargainMeList()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getBargainMeList()
		},
		/**
		 * 获取砍价次数和砍价列表
		 */
		getData() {
			// 公共获取剩余砍价次数
			this.$store.dispatch('bargain/onGetBargainCount')
			this.getBargainMeList()
		},
		/**
		 * 按钮操作之后重新获取数据
		 */
		onReload() {
			this.getData()
		}
	},
  async created() {
    this.showAlert()
		await this.setTab()
		this.getData()
	}
}
